// extracted by mini-css-extract-plugin
export var container = "_i9-0";
export var infoIcon = "_i9-2";
export var internalLabel = "_i9-3";
export var titleRowCol = "_i9-1";